const RouteTemp = () => import(/*webpackChunkName:'finance'*/'@/page/commons/routeTemp.vue')

const DailyStatement= () => import(/*webpackChunkName:'finance' */'@/page/finance/rent-month-order/daily-statement.vue');
const MonthlyStatement= () => import(/*webpackChunkName:'finance' */'@/page/finance/rent-month-order/monthly-statement.vue');
export const rentMonthOrder={
    path: '/main/finance/rent-month-order',
    name: '月年租卡',
    meta: {
        requireAuth: true,

    },
    component: RouteTemp,
    children: [

        {
            path: '/main/finance/rent-month-order/daily-statement',
            name: '日报统计',
            meta: {
                requireAuth: true,
            },
            component: DailyStatement
        }, {
            path: '/main/finance/rent-month-order/monthly-statement',
            name: '月报统计',
            meta: {
                requireAuth: true,
            },
            component: MonthlyStatement
        }]
}